import { useField } from 'formik';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

function Selectinput(props) {
  const { label, name, width = '100%', options, ...rest } = props;
  const [field, meta] = useField(name);
  const configTextfield = {
    ...field,
    ...rest,
    label,
    options,
    fullWidth: true,
    variant: 'outlined'
  };

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }
  return (
    <FormControl style={{ marginTop: 15 }} fullWidth variant="outlined">
      <InputLabel>{label}</InputLabel>
      <Select {...configTextfield}>
        {options.map((option) => {
          return (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default Selectinput;
